import type { FlagValuesMap } from '@/domains/core/flags/flags.state';

export const mapAbPool = (
  abTestNew: FlagValuesMap,
): Record<string, boolean> => {
  const poolXAA = abTestNew['ft-cross-sell-xaa'];
  const poolAXA = abTestNew['ft-cross-sell-axa'];
  const poolAAX = abTestNew['ft-cross-sell-aax'];

  return {
    xaa: typeof poolXAA === 'string' && poolXAA.length > 0,
    axa: typeof poolAXA === 'string' && poolAXA.length > 0,
    aax: typeof poolAAX === 'string' && poolAAX.length > 0,
  };
};
